// The statement period, as the month an operator picks and the two dates the
// service wants.
//
// `from_date` and `to_date` are inclusive on the commission endpoint, so the
// range runs to the last day of the month rather than the first of the next.

function pad(value) {
  return value < 10 ? '0' + value : String(value);
}

export function currentMonth() {
  var now = new Date();
  return now.getFullYear() + '-' + pad(now.getMonth() + 1);
}

export function isValidMonth(month) {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(String(month || ''));
}

// '2026-10' -> { from_date: '2026-10-01', to_date: '2026-10-31' }
export function monthRange(month) {
  if (!isValidMonth(month)) return null;
  var parts = String(month).split('-');
  var year = Number(parts[0]);
  var monthNumber = Number(parts[1]);
  // Day 0 of the next month is the last day of this one, which gets February
  // and leap years right without a table.
  var lastDay = new Date(year, monthNumber, 0).getDate();
  return {
    from_date: month + '-01',
    to_date: month + '-' + pad(lastDay)
  };
}

var MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

// 'October 2026' for the statement header.
export function monthLabel(month) {
  if (!isValidMonth(month)) return '';
  var parts = String(month).split('-');
  return MONTH_NAMES[Number(parts[1]) - 1] + ' ' + parts[0];
}
